/* eslint-disable react/prop-types */
import React from 'react';
import moment from 'moment-timezone';
import { MaterialUiPickers } from '@gscope-mfe/common-libs';
const { KeyboardDatePicker } = MaterialUiPickers;
export default function DatePicker(props) {
    const { label, filterName, updateParentState } = props;
    const [selectedDate, setSelectedDate] = React.useState();

    const handleDateChange = (date) => {
        setSelectedDate(moment(date).format());
        updateParentState(filterName, moment(date).format());
    };

    return (
        <KeyboardDatePicker
            id="date-picker"
            value={moment(selectedDate).format()}
            variant="inline"
            inputVariant="outlined"
            label={label}
            onChange={(date) => handleDateChange(date)}
            placeholder="mm/dd/yyyy"
            format="MM/DD/YYYY"
        />
    );
}
